import { Flex } from "@fluentui/react-northstar";
import React from "react";
import { Outlet, useLocation } from "react-router-dom";
import CustomBreadCrumb from "../../components/breadcrumb";
import { NAV_LIST } from "./constant";
import { _getAllAgencies, _getAllOffboardingAgencies } from "./api";
import DialogPrepareOffboarding from "./components/dialogPrepareOffboarding/DialogPrepareOffboarding";

export default function Offboarding() {
    return (
        <Flex
            styles={{
                minHeight: "100vh",
                backgroundColor: "#F5F5F5",
            }}
            column
        >
            <CustomBreadCrumb
                navList={NAV_LIST}
                actions={<DialogPrepareOffboarding />}
            />

            <Outlet />
        </Flex>
    );
}
